import { render, staticRenderFns } from "./TileSwitcher.vue?vue&type=template&id=23f05977"
import script from "./TileSwitcher.vue?vue&type=script&lang=js"
export * from "./TileSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports